import _Promise from 'babel-runtime/core-js/promise';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

var _this = this;

import listeners from '../listeners';
import injected from '../injected';
import makeRequest from './request';
import get from 'lodash/get';
import { instance as axios } from './instance';

var isRefreshing = false;
var refreshSubscribers = [];

// we init a long time ago so when the first refresh is just
// after the init of this date, it doesn'ttrigger an error message
var lastRefreshed = new Date(2018, 1, 1);

var processRefreshSubscribers = function processRefreshSubscribers(method) {
  refreshSubscribers.forEach(function (subscriber) {
    var originalRequest = subscriber.originalRequest;
    if (method === 'resolve') {
      subscriber.resolve(axios(originalRequest));
    } else {
      subscriber.reject(subscriber.error);
    }
  });
  refreshSubscribers = [];
};

var getRefreshToken = function getRefreshToken() {
  var now = new Date();
  isRefreshing = true;
  if (now - lastRefreshed < 5000) {
    console.error('last refresh happened less than 5 seconds ago');
  }
  lastRefreshed = now;
  var params = {};
  if (injected.getRefreshToken) {
    var refreshToken = injected.getRefreshToken();
    params.refreshToken = refreshToken;
  }
  /* catch is empty because in case of error : its handled by the error interceptor (below) */
  makeRequest('get', '/authenticate/refresh-token', null, { params: params }).then(function (data) {
    listeners.onTokenChange(data);
    isRefreshing = false;
    lastRefreshed = now;

    /* retry all subscribers requests with new cookie */
    processRefreshSubscribers('resolve');
  }).catch(function () {
    isRefreshing = false;
    processRefreshSubscribers('reject');
  });
};

var request = {
  success: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(config) {
      var idToken;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (injected.getIdToken) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return', config);

            case 2:
              _context.next = 4;
              return injected.getIdToken();

            case 4:
              idToken = _context.sent;

              if (idToken) {
                _context.next = 7;
                break;
              }

              return _context.abrupt('return', config);

            case 7:
              config.headers = config.headers || {};
              config.headers.authorization = 'Bearer ' + idToken;
              return _context.abrupt('return', config);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function success(_x) {
      return _ref.apply(this, arguments);
    };
  }(),
  error: function error(_error) {
    return _Promise.reject(_error);
  }
};

export { request };
var response = {
  success: function success(response) {
    return response;
  },
  error: function error(_error2) {
    var promise = void 0;
    var originalRequest = _error2.config;

    if (!originalRequest) {
      return _Promise.reject(_error2);
    }

    /* if the signout request fail : do nothing because dispatch session/remove is already called */
    if (originalRequest.url.indexOf('authenticate/signout') !== -1) {
      return _Promise.reject(_error2);
    }

    /* if refresh token failed : reject all requests, remove session and redirect to login page */
    if (originalRequest.url.indexOf('authenticate/refresh-token') !== -1) {
      listeners.onRefreshTokenFailed();
      return _Promise.reject(_error2);
    }

    /* subscribe this request for later resolve|reject (processRefreshSubscribers) */
    if (get(_error2, 'response.status') === 401 && get(_error2, 'response.data.code') === 'ExpiredToken' || get(_error2, 'response.data.code') === 'TokenNotPresent') {
      promise = new _Promise(function (resolve, reject) {
        refreshSubscribers.push({ originalRequest: originalRequest, resolve: resolve, reject: reject, error: _error2 });
      });

      /* only try to refresh token ONCE - if status 401 */
      if (!isRefreshing) {
        getRefreshToken();
      }

      /* return a promise to wait for refresh token and retry */
      return promise;
    }

    if (get(_error2, 'response.status') === 401) {
      listeners.onAuthenticationError(_error2);
    }

    /* any error case will reject the request */
    return _Promise.reject(_error2);
  }
};
export { response };
//# sourceMappingURL=interceptors.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-api/lib/utils/interceptors.js
// module id = 1073
// module chunks = 0